import { render, staticRenderFns } from "./shopQualification.vue?vue&type=template&id=a65093f4&scoped=true"
import script from "./shopQualification.vue?vue&type=script&lang=js"
export * from "./shopQualification.vue?vue&type=script&lang=js"
import style0 from "./shopQualification.vue?vue&type=style&index=0&id=a65093f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65093f4",
  null
  
)

export default component.exports